"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableHeaderFilter = TableHeaderFilter;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _filterUtils = require("./filterUtils");

var _Input = require("../forms/Input");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function onFilterChange(onChange) {
  return function (event) {
    onChange({
      filter: (0, _filterUtils.filterContains)(event.target.value),
      value: event.target.value
    });
  };
}

function TableHeaderFilter(props) {
  var value = (0, _filterUtils.getSanitizedValue)(props.valueObject);
  return /*#__PURE__*/_react["default"].createElement(_Input.Input, {
    cssClassModifiers: ['small-relative'],
    placeholder: props.placeholder,
    value: value,
    onChange: onFilterChange(props.onChange)
  });
}

TableHeaderFilter.propTypes = {
  onChange: _propTypes["default"].func.isRequired,
  placeholder: _propTypes["default"].string,
  valueObject: _propTypes["default"].shape({
    value: _propTypes["default"].string.isRequired,
    filter: _propTypes["default"].func.isRequired
  })
};
TableHeaderFilter.defaultProps = {
  placeholder: '',
  valueObject: null
};